import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";
import "./index.css";
import { useThemeStore } from "@/shared/stores/themeStore";

// Initialize theme as early as possible
useThemeStore.getState();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
